import React, { memo, useCallback, useMemo, useState } from "react"
import { exportCSVFile, exportXlsx } from "../../../utils/exportFile";
import useSortableData from "../../../hooks/useSortableData";
import useFilterData from "../../../hooks/useFilterData";
import PaginationButtons, { dataPagination } from "../../PaginationButtons";
import Button from "../../bootstrap/Button";
import FormGroup from "../../bootstrap/forms/FormGroup";
import Input from "../../bootstrap/forms/Input";
import Modal, { ModalBody, ModalHeader } from "../../bootstrap/Modal";
import Icon from "../../icon/Icon";
import ModalSectorPdf from "../../modals/SectorPdf/modalSector";

const TableCustomDelivery = ({
    columns,
    categoriesData,
    categoryActions,
    rows,
    keyExtractor,
    noShowHeader,
    title,
    noShowPagination = false,
    fontSize,
    icon,
    titlePdf,
    fileName
}) => {

    const [search, setsearch] = useState('');

    const dataFilter = useFilterData(rows || [], search);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(dataFilter);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);
    const [showExportModal, setShowExportModal] = useState(false);
    const [openModalEvent, setOpenModalEvent] = useState(false);
    const [expandedCategories, setExpandedCategories] = useState(new Set());

    const handleOpenModalEvent = () => {
        setOpenModalEvent(true);
    };
    const handleCloseModalEvent = () => {
        setOpenModalEvent(false);
    };

    const onExport = useCallback(() => {
        setShowExportModal(true);
    }, []);

    const onExportCSV = useCallback(() => {
        let dataExport = [];

        if (categoriesData) {
            groupedData.forEach(category => {
                category.products.forEach(product => {
                    const data = {};
                    data['CATEGORIA'] = category.name;
                    columns.forEach((c) => {
                        if (c.noExport) return;
                        const field = c.field;
                        let cell = c.formatExport
                            ? c.formatExport(field === '{row}' ? product : product[field])
                            : product[field];
                        cell = cell === undefined ? ' ' : cell;
                        data[c.label.toUpperCase()] = cell;
                    });
                    dataExport.push(data);
                });
            });
        } else {
            dataExport = dataFilter.map((row) => {
                const data = {};
                columns.forEach((c) => {
                    if (c.noExport) return;
                    const field = c.field;
                    let cell = c.formatExport
                        ? c.formatExport(field === '{row}' ? row : row[field])
                        : row[field];
                    cell = cell === undefined ? ' ' : cell;
                    data[c.label.toUpperCase()] = cell;
                });
                return data;
            });
        }

        exportCSVFile(dataExport, fileName || 'dados');
    }, [columns, categoriesData, groupedData, dataFilter, fileName]);

    const onExportXLS = async () => {
        const visibleColumns = columns.filter(c => !c.hidden && !c.noExport);

        if (categoriesData) {
            const flatData = [];
            groupedData.forEach(category => {
                category.products.forEach(product => {
                    flatData.push({
                        ...product,
                        categoryName: category.name
                    });
                });
            });
            exportXlsx(flatData, [...[{ field: 'categoryName', label: 'Categoria' }], ...visibleColumns], fileName || 'dados');
        } else {
            exportXlsx(dataFilter, visibleColumns, fileName || 'dados');
        }
    };

    const columnsRender = useMemo(() => columns.filter(c => !c.hidden), [columns]);

    const groupedData = useMemo(() => {
        if (categoriesData) {
            return categoriesData.filter(category => {
                if (!search) return category.products && category.products.length > 0;

                const categoryMatch = category.name?.toLowerCase().includes(search.toLowerCase());
                const productsMatch = category.products && category.products.some(product =>
                    product.name?.toLowerCase().includes(search.toLowerCase())
                );

                return categoryMatch || productsMatch;
            }).map(category => ({
                ...category,
                products: category.products ? category.products.filter(product => {
                    if (!search) return true;
                    return product.name?.toLowerCase().includes(search.toLowerCase()) ||
                        category.name?.toLowerCase().includes(search.toLowerCase());
                }) : []
            })).filter(category => category.products.length > 0);
        } else {
            const groups = {};
            onCurrentPageData.forEach(item => {
                const categoryName = item.categoryName || item.category || 'Sem Categoria';
                if (!groups[categoryName]) {
                    groups[categoryName] = [];
                }
                groups[categoryName].push(item);
            });
            return Object.entries(groups).map(([name, products]) => ({
                categoryId: name,
                name: name,
                products: products
            }));
        }
    }, [categoriesData, onCurrentPageData, search]);

    const toggleCategory = useCallback((categoryId) => {
        setExpandedCategories(prev => {
            const newSet = new Set(prev);
            if (newSet.has(categoryId)) {
                newSet.delete(categoryId);
            } else {
                newSet.add(categoryId);
            }
            return newSet;
        });
    }, []);

    const dataPDF = [{
        fontSize: fontSize,
        title: titlePdf,
        icon: icon,
        columns: columns,
        data: categoriesData || rows || [],
    }];

    return (
        <>
            <div className='d-flex' style={{ marginBottom: 20 }} >
                <h4>{title}</h4>
                {!noShowHeader &&
                    <div className='d-flex flex-grow-1 flex-row-reverse'>
                        {/* <Button
                            style={{ marginLeft: 20, paddingTop: 0, paddingBottom: 0 }}
                            className='text-dark'
                            type='button'
                            color='warning'
                            icon="Download"
                            hoverShadow="sm"
                            shadow="sm"
                            size="sm"
                            onClick={onExport}
                        >
                            Exportar
                        </Button> */}
                        <FormGroup id="name" label="" className='col-md-3'>
                            <Input
                                onChange={e => {
                                    setsearch(e.target.value);
                                    if (currentPage !== 1) {
                                        setCurrentPage(1);
                                    }
                                }}
                                value={search}
                                placeholder='Buscar'
                            />
                        </FormGroup>
                    </div>}
            </div>
            <Modal
                id={'modal-export'}
                isOpen={showExportModal}
                setIsOpen={setShowExportModal}
                isStaticBackdrop={true}
                isCentered={true}
                size="md"
            >
                <ModalHeader className="modal-title">
                    <h3 className="fw-bold">Exportar</h3>
                    <button type="button" className="btn-close" onClick={() => setShowExportModal(false)}></button>
                </ModalHeader>
                <ModalBody>
                    <div className='d-flex justify-content-center align-items-center gap-2'>
                        <Button
                            className="bg-danger text-white fs-5 col-md-4"
                            onClick={handleOpenModalEvent}
                        >
                            <Icon icon='PictureAsPdf' size={'2x'} /> PDF
                        </Button>
                        <Button
                            className="bg-success text-white fs-5 col-md-4"
                            onClick={onExportCSV}
                        >
                            <Icon icon='LibraryBooks' size={'2x'} /> CSV
                        </Button>
                        <Button
                            className="bg-success text-white fs-5 col-md-4"
                            onClick={onExportXLS}
                        >
                            <Icon icon='LibraryBooks' size={'2x'} /> XLS
                        </Button>
                    </div>
                </ModalBody>
            </Modal >

            <div className='table-responsive'>
                <div className='delivery-table-container'>
                    {groupedData.map((category) => (
                        <div key={category.categoryId} className='category-group mb-4'>
                            {/* Header da Categoria */}
                            <div
                                className='category-header d-flex align-items-center p-3 bg-light rounded cursor-pointer'
                                onClick={() => toggleCategory(category.categoryId)}
                                style={{ cursor: 'pointer' }}
                            >
                                <Icon
                                    icon={expandedCategories.has(category.categoryId) ? 'ExpandLess' : 'ExpandMore'}
                                    className="me-2"
                                />
                                <h5 className='mb-0 me-3'>{category.name}</h5>
                                <span className='badge bg-primary'>{category.products.length} itens</span>
                                {categoryActions && (
                                    <div
                                        className='ms-auto d-flex align-items-center gap-2'
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                    >
                                        {categoryActions(category)}
                                    </div>
                                )}
                            </div>

                            {/* Tabela da Categoria */}
                            {expandedCategories.has(category.categoryId) && (
                                <div className='category-content mt-2'>
                                    <table className='table table-modern table-striped'>
                                        <thead>
                                            <tr>
                                                {columnsRender.map((column) => (
                                                    <th key={'tab-head-' + column.label} onClick={() => requestSort(column.field)}>
                                                        {column.label.toUpperCase()}
                                                        <Icon
                                                            size='sm'
                                                            className={getClassNamesFor(column.field)}
                                                            icon='FilterList'
                                                        />
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {category.products.map((item, index) => (
                                                <tr key={keyExtractor ? keyExtractor(item) : item.id}>
                                                    {columnsRender.map((c, index2) => (
                                                        <td
                                                            key={`tab-cell-${item.id}-${index}-${index2}`}
                                                            style={{
                                                                maxWidth: '50px',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                textOverflow: 'ellipsis'
                                                            }}
                                                        >
                                                            {c.format ? c.format(item) : item[c.field]}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    ))}

                    {groupedData.length === 0 && (
                        <div className='text-center p-4'>
                            <Icon icon='SearchOff' size='3x' className='text-muted mb-3' />
                            <h5 className='text-muted'>Nenhum resultado encontrado</h5>
                        </div>
                    )}
                </div>
            </div>

            <ModalSectorPdf
                open={openModalEvent}
                setIsOpen={setOpenModalEvent}
                setIsClose={handleCloseModalEvent}
                data={dataPDF}
                fileName={fileName}
            />

            {!noShowPagination &&
                <PaginationButtons
                    data={categoriesData ? groupedData : items}
                    label={categoriesData ? 'categorias' : 'items'}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                />
            }
        </>
    )
}

export default memo(TableCustomDelivery)
